import { render, staticRenderFns } from "./TaskUpdatedPriority.vue?vue&type=template&id=53c92343&scoped=true"
import script from "./TaskUpdatedPriority.vue?vue&type=script&lang=js"
export * from "./TaskUpdatedPriority.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c92343",
  null
  
)

export default component.exports